import { render } from "./UiMusicPlayer.vue?vue&type=template&id=405b991f"
import script from "./UiMusicPlayer.vue?vue&type=script&lang=js"
export * from "./UiMusicPlayer.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__